import { useEffect, useState } from "react";
import {
    api, getTicketTypeById, getTicketTypeInfosByTicketTypeId, getAdmittedPaymentTypesOfOrder, getAdmittedDeliveryMethodsOfOrder,
    getOccupancy, getSeatBySeatId
} from "ticketino-api-client";
import axios from 'axios';
import parse from "html-react-parser";

import Loading from "./Loading";

/* eslint eqeqeq: "off" */

const PaymentType = (props) => {

    const htmlElement = document.getElementById("ticketinoShopPlugin");

    //----variables----//

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;
    const datatransUrl = process.env.REACT_APP_DATATRANS_TICKETINO;

    //prop values
    const orderId = props.orderId;
    const token = props.token;
    const allowPromtionCode = props.allowPromtionCode;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const selectedLanguageCode = props.languageCode;
    const allowInsurance = props.allowInsurance;
    const ticketTypesInformation = props.ticketTypesInformation;
    const organizerId = props.organizerId; 
    const organizerUrl = props.organizerUrl;

    //mutateable
    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);

    const [payment, setPayment] = useState({
        paymentMethodId: 0,
        deliveryMethodId: 0,
        insurance: false
    })

    const [loading, setLoading] = useState(true);
    const [promotionCode, setPromotionCode] = useState();
    const [promotionCodeMessage, setPromotionCodeMessage] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [resources, setResources] = useState([]);

    var deliveryTypes = [
        { display: resources.detailPage?.PrintAtHome, description: resources.detailPage?.PrintAtHomeDesc, id: 1 },
        { display: resources.detailPage?.PostVersand, description: resources.detailPage?.PostVersandDesc, id: 2 },
    ];

    const [allowedDeliveryMethods, setAllowedDeliveryMethods] = useState([]);

    const [paymentTypes, setPaymentTypes] = useState([
        { id: 1, paymentMethodGroupId: 4, display: "", description: "" },
        { id: 2, paymentMethodGroupId: 2, display: "", description: "" },
        { id: 7, paymentMethodGroupId: 4, display: "", description: "" },
        { id: 8, paymentMethodGroupId: 4, display: "", description: "" },
        { id: 9, paymentMethodGroupId: 10, display: "", description: "" },
        { id: 10, paymentMethodGroupId: 9, display: "", description: "" },
        { id: 14, paymentMethodGroupId: 4, display: "", description: "" },
        { id: 16, paymentMethodGroupId: 4, display: "", description: "" }
    ]);

    const handledByDatatrans = [1, 7, 8, 9, 10, 11, 14, 16];
    const handledByTicketino = [2, 4, 5, 6];

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        api.defaults.baseURL = baseUrl;

        scrollView();
        loadOrder(orderId);
    }, []);

    useEffect(() => {
        requestResources(selectedLanguage);
    }, [selectedLanguage]);

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);

                setPaymentTypes((prevPaymentTypes) => {
                    return prevPaymentTypes.map((ppt) => {
                        if (ppt.id === 1) {
                            ppt.display = res.data.detailPage?.MasterCard;
                            ppt.description = res.data.detailPage?.MasterCardDesc;
                        } else if (ppt.id === 2) {
                            ppt.display = res.data.detailPage?.Invoice;
                            ppt.description = res.data.detailPage?.InvoiceDesc;
                        } else if (ppt.id === 7) {
                            ppt.display = res.data.detailPage?.Visa;
                            ppt.description = res.data.detailPage?.VisaDesc;
                        } else if (ppt.id === 8) {
                            ppt.display = res.data.detailPage?.AmericanExpress;
                            ppt.description = res.data.detailPage?.AmericanExpressDesc;
                        } else if (ppt.id === 9) {
                            ppt.display = res.data.detailPage?.PostFinance;
                            ppt.description = res.data.detailPage?.PostFinanceDesc;
                        } else if (ppt.id === 10) {
                            ppt.display = res.data.detailPage?.PayPal;
                            ppt.description = res.data.detailPage?.PayPalDesc;
                        } else if (ppt.id === 14) {
                            ppt.display = res.data.detailPage?.Twint;
                            ppt.description = res.data.detailPage?.TwintDesc;
                        } else if (ppt.id === 16) {
                            ppt.display = res.data.detailPage?.GooglePay;
                            ppt.description = res.data.detailPage?.GooglePayDesc;
                        }
                        return { ...ppt };
                    })
                })
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            const order = await getOrderByOrderId(orderId);

            if (order) {
                const tickets = await getTicketsByOrderId(orderId);

                const updatedTickets = await Promise.all(
                    tickets.map(async (ticket) => {
                        const ticketType = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId) ?? await getTicketTypeById(ticket.ticketTypeId);
                        const info = ticketTypesInformation.find((tti) => tti.id == ticket.ticketTypeId)?.info ?? await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);


                        let seatDetails = {};
                        if (ticket.occupancyId != null && ticket.occupancyId > 0) {
                            let occupancy = await getOccupancy(ticket.occupancyId);
                            if (occupancy) {
                                seatDetails = await getSeatBySeatId(occupancy.seatId);
                            }
                        }

                        const eventId = ticketType.eventId;

                        if (eventId > 0) {
                            const eventPaymentMethodGroups = await getEventPaymentMethodGroups(eventId);

                            // filter out the payment types which arent included in the payment method groups of the event
                            setPaymentTypes((prevPaymentTypes) => {
                                return prevPaymentTypes.filter(paymentType => eventPaymentMethodGroups.includes(paymentType.paymentMethodGroupId))
                            })
                        }

                        // remove the invoice payment type if the invoice period has already ended
                        if (ticketType?.invoiceEnd) {
                            const currentDate = new Date();
                            const invoiceEnd = new Date(ticketType.invoiceEnd)

                            if (invoiceEnd < currentDate) {
                                setPaymentTypes((prevPaymentTypes) => { return prevPaymentTypes.filter(p => p.id != 2) });
                            }
                        }

                        return { ...ticket, ticketType: ticketType, info: info, seatDetails: seatDetails }
                    })
                )

                if (order.totalPrice == 0) {
                    await axios.put(`${baseUrl}/ShopBasket/Order/${order.id}/PaymentType/5`);
                }

                var admittedPaymentTypeIds = await getAdmittedPaymentTypesOfOrder(orderId);

                //only display the payment types available to the order
                if (admittedPaymentTypeIds.length > 0) {
                    setPaymentTypes((prevPaymentTypes) => { return prevPaymentTypes.filter(p => admittedPaymentTypeIds.includes(p.id)) });
                }

                var admittedDelieryMethodIds = await getAdmittedDeliveryMethodsOfOrder(orderId);
                
                //only display the delivery methods available to the order
                if (admittedDelieryMethodIds.length > 0) {
                    setAllowedDeliveryMethods(admittedDelieryMethodIds);
                }

                setPayment({ ...payment, paymentMethodId: order.paymentMethodId, deliveryMethodId: order.deliveryMethodId, insurance: (order.totalInsuranceAmount > 0) })
                setOrder(order)
                setTickets(updatedTickets);

                setLoading(false);
            } else {
                props.changeOrderId(0);
                props.changePage(-1);
            }

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getEventPaymentMethodGroups = async (eventId) => {
        try {
            const res = await axios.get(`${baseUrl}/Event/${eventId}/PaymentMethodGroups`);
            return res.data
        } catch (error) {
            console.error(error);
        }
    }

    const getTicketsByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}/Tickets`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }

    const confirmOrderByOrderId = async (id) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${id}/Confirm`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const changePaymentType = async (id) => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${id}`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                setErrorMessage(resources.detailPage?.paymentmethodError);
            });
    }

    const changeDeliveryType = async (id) => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${id}`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                setErrorMessage(resources.detailPage?.deliverymethodError);
            });
    }

    const setOrderInsurance = async () => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            });
    }

    const removeOrderInsurance = async () => {
        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            });
    }

    const updatePromotionCode = async () => {

        if (/^([a-z A-Z0-9öéàäèü -]{0,70})$/.test(promotionCode) == false) {
            setPromotionCodeMessage("Illegal Entry");
            return null;
        }

        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotionCode}`)
            .then(() => {
                loadOrder(orderId)
                setPromotionCodeMessage(resources.detailPage?.successsMessage);
            }).catch((error) => {
                setPromotionCodeMessage(resources.detailPage?.errorMessage);
            });
    }

    const scrollView = () => {
        var scrollElement = document.getElementById("ticketinoScrollElement");

        if (scrollElement) {
            scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    //start the datatrans process
    const startDatatrans = async () => {

        //var languageISO = htmlElement.getAttribute("languageISO");
        //var organizerId = htmlElement.getAttribute("organizerId");

        axios
            .get(`${datatransUrl}/Datatrans/${orderId}/DigitalSignature`)
            .then((res) => {
                let datatransFormId = "datatrans-" + new Date().getTime();
                var form =
                    "<form className='datatrans' id='" + datatransFormId + "'></form>";

                let container = document.getElementById("datatrans-form-placeholder");

                container.innerHTML += form;

                let element = document.getElementById(datatransFormId);

                // merchantId for testing
                // element.setAttribute("data-merchant-id", "1100004624");
                element.setAttribute("data-merchant-id", res.data.merchantId);
                element.setAttribute("data-amount", res.data.amount);
                element.setAttribute("data-currency", res.data.currency);
                element.setAttribute("data-refno", res.data.referenceNumber);
                element.setAttribute("data-reqType", res.data.reqType);
                element.setAttribute(
                    "data-upp-return-target",
                    res.data.uppReturnTarget
                );
                element.setAttribute("data-paymentMethod", res.data.paymentMethod);
                element.setAttribute("data-sign", res.data.digitalSignature);

                let successUrl = `${baseProxyUrl}/confirm/success/${orderId}?languageCode=${selectedLanguage}`;
                if (organizerUrl) successUrl += `&organizerUrl=${organizerUrl}`;

                element.setAttribute("data-success-url", successUrl);
                element.setAttribute("data-error-url", `${baseProxyUrl}/confirm/error/${orderId}?organizerId=${organizerId}&languageCode=${selectedLanguage}`);
                element.setAttribute("data-cancel-url", `${baseProxyUrl}/confirm/cancel/${orderId}?organizerId=${organizerId}&languageCode=${selectedLanguage}`);

                for (const key in res.data.userInfo) {
                    element.setAttribute(key, res.data.userInfo[key]);
                }

                for (const key in res.data.merchantSpecificParameters) {
                    element.setAttribute(key, res.data.merchantSpecificParameters[key]);
                }

                // start datatrans -> call the payment form
                window.Datatrans.startPayment({
                    form: "#" + datatransFormId,
                });
            });
    }

    const onSubmit = async () => {
        if (order.totalPrice == 0) {
            // changing the payment type to free
            await changePaymentType(5);
            const order = await confirmOrderByOrderId(orderId);

            if (order) {
                props.changePage(1);
            }
        }

        if (order.totalPrice > 0) {
            if (handledByDatatrans.includes(payment.paymentMethodId)) {
                await startDatatrans();
            }

            if (handledByTicketino.includes(payment.paymentMethodId)) {
                const order = await confirmOrderByOrderId(orderId);
                if (order) {
                    props.changePage(1);
                }
            }
        }
    }

    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-auto">
                        <select
                            className="ticketinoSelect selectNum form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}>
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>

                        </select>
                    </div>
                </div>
                <p className="ticketinoText text titleStyle text-start text-center fs-3 fw-semibold mb-2">{resources.detailPage?.title}</p>
                <p className="ticketinoText text fs-6 text-center">{resources.detailPage?.instruction}</p>
            </div>
        )
    }

    const paymentTypesDiv = () => {
        return (
            <>
                <p className="fs-5 text">{resources.detailPage?.labelPaymentmethod}</p>
                {paymentTypes.map((type) => (
                    <div className="mb-4">
                        <div className="form-check mb-3">
                            <input
                                className="form-check-input me-2"
                                type="radio"
                                name="flexRadioDefault1"
                                checked={payment.paymentMethodId === type.id ? true : false}
                                onClick={() => changePaymentType(type.id)}
                                id="printAtHome"
                            />
                            <label
                                className="form-check-label fs-6"
                                htmlFor="flexRadioDefault1"
                            >
                                {type.display}
                                <p className="pt-1 m-0 text-secondary">
                                    {type.description}
                                </p>
                            </label>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    const deliveryTypesDiv = () => {

        return (
            <>
                <p className="fs-5 text">{resources.detailPage?.labelDeliverymethod}</p>
                {deliveryTypes.map((type) => allowedDeliveryMethods.includes(type.id) && (
                    <div className="mb-4">
                        <div className="form-check mb-3">
                            <input
                                className="form-check-input me-2"
                                type="radio"
                                name="flexRadioDefault2"
                                checked={payment.deliveryMethodId === type.id ? true : false}
                                onClick={() => changeDeliveryType(type.id)}
                                id="printAtHome"
                            />
                            <label
                                className="form-check-label fs-6"
                                htmlFor="flexRadioDefault2"
                            >
                                {type.display}
                                <p className="pt-1 m-0 text-secondary">
                                    {type.description}
                                </p>
                            </label>
                        </div>
                    </div>
                ))}
            </>
        )
    }

    const promotionCodeDiv = () => {
        return (
            <>
                <p className="fs-5 text">{resources.detailPage?.labelPromotioncode}</p>
                <div className="row mb-3">
                    <div className="col-md-8 col-12 mb-2">
                        <input
                            type="text"
                            name="firstname"
                            className="ticketinoInput form-control inputCodeFirstname"
                            id="inputCode"
                            onChange={(event) => {
                                setPromotionCode(event.currentTarget.value);
                            }}
                        />
                    </div>
                    <div className="col-md-4 col-12 mb-2">
                        <button className="ticketinoButton btn button btn-light" onClick={updatePromotionCode} >
                            {resources.detailPage?.buttonLabelUseCode}
                        </button>
                    </div>
                    <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                        {promotionCodeMessage}
                    </div>
                </div>
            </>
        )
    }

    const insuranceDiv = () => {
        return (
            <>
                <p className="fs-5 text">{resources.detailPage?.insuranceLabel}</p>
                <div className="form-check mb-4">
                    <input
                        onChange={(e) => {
                            if (e.target.checked) {
                                setOrderInsurance();
                            } else {
                                removeOrderInsurance();
                            }
                        }}
                        className="ticketinoInput form-check-input"
                        name="AcceptAGB"
                        type="checkbox"
                        id="InsuranceCheckbox"
                        checked={payment.insurance}
                    />
                    <label className="ticketinoLabel text">
                        {parse(resources.detailPage?.insuranceDesc ?? "")}
                    </label>
                </div>
            </>
        )
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets];
        }

        ticketsSorted = ticketsSorted.map((ticket) => {
            const ticketTypeInfo = ticket.info?.find(info => info.languageId === selectedLanguageCode) ?? ticket.info?.find(info => info.languageId === 0);

            //taking the default value when info doesnt exist
            return { ...ticket, info: ticketTypeInfo };
        });

        return (
            tickets.length > 0 && ticketsSorted.map((ticket, key) => (
                <li className="list-group-item" key={key}>
                    <div className="row m-0 p-1 tickets">
                        <div className="col-8 text fs-6 ticketinoText">
                            {ticket.info?.name}
                            {ticket.seatDetails && Object.keys(ticket.seatDetails).length > 0 && <div className="form-text">{resources.detailPage?.SeatingPlace}: {resources.detailPage?.Row} {ticket.seatDetails.rowName}, {resources.detailPage?.Seat} {ticket.seatDetails.name}</div>}

                        </div>
                        <div className="col-4 text fs-6 ticketinoText text-end">
                            {ticket.currency} {ticket.price?.toFixed(2)}
                        </div>
                    </div>
                </li>
            ))

        )
    }

    const mapExtraCosts = () => {
        return (
            <>
                {order.deliverPaymentFee > 0 && order.deliverPaymentFee != null && <li className="list-group-item">
                    <div className="row m-0 p-1 tickets">
                        <div className="col-8 text fs-6 ticketinoText">
                            {resources.detailPage?.feeLabel}
                        </div>
                        <div className="col-4 text fs-6 ticketinoText text-end">
                            {order.currency} {order.deliverPaymentFee?.toFixed(2)}
                        </div>
                    </div>
                </li>}
                {payment.insurance && order.totalInsuranceAmount > 0 && order.totalInsuranceAmount != null && <li className="list-group-item">
                    <div className="row m-0 p-1 tickets">
                        <div className="col-8 text fs-6 ticketinoText">
                            {resources.detailPage?.insuranceLabel}
                        </div>
                        <div className="col-4 text fs-6 ticketinoText text-end">
                            {order.currency} {order.totalInsuranceAmount?.toFixed(2)}
                        </div>
                    </div>
                </li>}
            </>
        )
    }

    const totalCosts = () => {
        return (
            <li className="list-group-item">
                <div className="row m-0 p-1 tickets fs-5 fw-bold">
                    <div className="col-8 text fs-6 ticketinoText">
                        {resources.detailPage?.totalLabel}
                    </div>
                    <div className="col-4 text fs-6 ticketinoText text-end">
                        {order.currency} {order.totalPrice?.toFixed(2)}
                    </div>
                </div>
            </li>
        )
    }


    //------HTML Display
    return (
        <div className="page-container">
            <div id="datatrans-form-placeholder"></div>
            {languageSelectDiv()}
            <div className="container">
                <div className="deliveryDiv">{deliveryTypesDiv()}</div>
                {(order.totalPrice > 0 || (payment.deliveryMethodId == 2 || payment.deliveryMethodId == 3)) &&
                    <div className="paymentDiv">{paymentTypesDiv()}</div>
                }
                <div>{allowPromtionCode == "true" && promotionCodeDiv()}</div>
                <div>{allowInsurance == "true" && insuranceDiv()}</div>
            </div>
            <div className="container">
                {loading ? <Loading /> : <>
                    <p className="fs-5 text">{resources.detailPage?.priceSummary}</p>
                    <ul className="list-group mb-4 ms-0 me-0">
                        {mapTickets()}
                        {mapExtraCosts()}
                        {totalCosts()}
                    </ul>
                </>}

                <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                    {errorMessage}
                </div>

                <button className="button btn-grey btn-ticketino-large  mb-3" onClick={() => props.changePage(-1)} >
                    {resources.detailPage?.buttonLabelPrevious}
                </button>
                <button className="button btn-orange btn-ticketino-large float-end" onClick={onSubmit} >
                    {resources.detailPage?.buttonLabelContinue}
                </button>
            </div>
        </div >
    )

}

export default PaymentType;